module.exports = __webpack_public_path__ + "static/media/pdf-icon-property-info.b37a0e08.png";